'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = function (componentOrElement) {
  return (0, _ownerDocument2["default"])(_reactDom2["default"].findDOMNode(componentOrElement));
};

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _ownerDocument = require('dom-helpers/ownerDocument');

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/bee-overlay-modal/build/utils/ownerDocument.js
// module id = 130
// module chunks = 0